import { pipe, path } from 'ramda'
import { sumProp } from '@v/util/briqRamdaExt.js'

export const pathToNumberOfPersonsPerSegment = path([
  'NumberOfPersonsPerClassification',
  0,
  'NumberOfPersonsPerSegment',
])

export const pathToQuantitiesPerSegment = path([
  'QuantitiesPerClassification',
  0,
  'QuantitiesPerSegment',
])

export const getTotalNumberOfPersons = pipe(
  pathToNumberOfPersonsPerSegment,
  sumProp('NumberOfPersons'),
)
